import { TreeDataNode } from "antd";
import { TreeSelectProps } from "rc-tree-select";
import { PickMulti } from "./BaseModel";

export interface Category {
  categoryId: number;
  categoryName: string;
  color: string | null;
  image: string | null;
  title: string;
}

export interface MerchantDetails {
  merchantId: number;
  merchantName: string;
  merchantCode: string;
  description: string;
}

export interface ProductTag {
  tagId: number;
  offerId?: string;
  tagNameAr: string | null;
  tagNameEn: string;
  id?: string;
  dateCreated?: string;
  dateModified?: string | null;
}

export const ProviderValues: TreeSelectProps["treeData"] = [
  {
    value: "Dsquares",
    title: "Dsquares",
    selectable: false,
    children: [
      {
        value: "1",
        title: "1",
      },
      {
        value: "14",
        title: "14",
      },
      {
        value: "15",
        title: "15",
      },
      {
        value: "2",
        title: "2",
      },
      {
        value: "MOBPROV001",
        title: "MOBPROV001",
      },
    ],
  },
  {
    value: "Donation",
    title: "Donation",
    selectable: false,
    children: [
      {
        value: "10",
        title: "10",
      },
    ],
  },
  {
    value: "Ascenda",
    title: "Ascenda",
    selectable: false,
    children: [
      {
        value: "11",
        title: "11",
      },
    ],
  },
  {
    value: "YOUGotaGift",
    title: "YOUGotaGift",
    selectable: false,
    children: [
      {
        value: "12",
        title: "12",
      },
      {
        value: "3",
        title: "3",
      },
      {
        value: "4",
        title: "4",
      },
      {
        value: "MOBGIFT001",
        title: "MOBGIFT001",
      },
    ],
  },
  {
    value: "AlFursan",
    title: "AlFursan",
    selectable: false,
    children: [
      {
        value: "5",
        title: "5",
      },
    ],
  },
  {
    value: "LikeCard",
    title: "LikeCard",
    selectable: false,
    children: [
      {
        value: "6",
        title: "6",
      },
    ],
  },
  {
    value: "Shukran",
    title: "Shukran",
    selectable: false,
    children: [
      {
        value: "8",
        title: "8",
      },
    ],
  },
  {
    value: "Qitaf",
    title: "Qitaf",
    selectable: false,
    children: [
      {
        value: "9",
        title: "9",
      },
    ],
  },
  {
    value: "blu AI",
    title: "blu AI",
    selectable: false,
    children: [
      {
        value: "BLUEXP001",
        title: "BLUEXP001",
      },
      {
        value: "BLUPRO001",
        title: "BLUPRO001",
      },
    ],
  },
  {
    value: "DaleelStore",
    title: "DaleelStore",
    selectable: false,
    children: [
      {
        value: "DSGC001",
        title: "DSGC001",
      },
      {
        value: "DSGM001",
        title: "DSGM001",
      },
    ],
  },
  {
    value: "Ehp",
    title: "Ehp",
    selectable: false,
    children: [
      {
        value: "EHP001",
        title: "EHP001",
      },
    ],
  },
  {
    value: "STC",
    title: "STC",
    selectable: false,
    children: [
      {
        value: "MOBSTCDIR001",
        title: "MOBSTCDIR001",
      },
    ],
  },
  {
    value: "Pos",
    title: "Pos",
    selectable: false,
    children: [
      {
        value: "PWP001",
        title: "PWP001",
      },
      {
        value: "RedeemPartner001",
        title: "RedeemPartner001",
      },
    ],
  },
  {
    value: "RewardCatalog",
    title: "RewardCatalog",
    selectable: false,
    children: [
      {
        value: "RCDC001",
        title: "RCDC001",
      },
      {
        value: "RCEXCHP001",
        title: "RCEXCHP001",
      },
      {
        value: "RCGC001",
        title: "RCGC001",
      },
    ],
  },
];

export type ProviderName = keyof typeof ProviderValues;

export interface Product {
  offerId: string;
  offerTypeId: number | null;
  offerType: string | null;
  offerNameEn: string;
  offerNameAr: string;
  offerNumber: string;
  offerDescriptionEn: string;
  offerDescriptionAr: string;
  offerIdentifier: string | null;
  offerStatusId: number | null;
  offerStatus: string;
  offerImage: string | null;
  parentOfferNumber: string | null;
  merchantId: string;
  merchantCode: string;
  merchantNameEn: string;
  merchantNameAr: string;
  merchantDescriptionEn: string | null;
  merchantDescriptionAr: string | null;
  merchantLogo: string | null;
  categoryId: number | null;
  categoryNameEn: string | null;
  categoryNameAr: string | null;
  categoryImage: string | null;
  categoryColor: string | null;
  projectValue: string;
  offerValues: string | null; // Comma separated string (e.g., "100,200")
  termsAndConditionsEn: string;
  termsAndConditionsAr: string;
  howToUseEn: string | null;
  howToUseAr: string | null;
  redeemUrl: string | null;
  conversionTypeEn: string | null;
  conversionTypeAr: string | null;
  redemptionTypeId: number | null;
  redemptionTypeEn: string | null;
  redemptionTypeAr: string | null;
  tagLineEn: string | null;
  tagLineAr: string | null;
  discountPercentage: number | null;
  isFavourite: boolean | null;
  value: number;
  amountEn: string | null;
  amountAr: string | null;
  points: number;
  discountType: number | null;
  sortingNumber: number | null;
  voucherValidityInMonths: number | null;
  voucherValidityInDays: number | null;
  offerCitiesId: string | null;
  isFrontend: boolean;
  provider: string;
  offerMaxDiscount: number | null;
  originalPrice: number | null;
  deliveryPrice: number | null;
  currency: string | null;
  startDate: string | null; // ISO Date String
  endDate: string | null; // ISO Date String
  expireDate: string | null; // ISO Date String
  modelEn: string | null;
  modelAr: string | null;
  subModelEn: string | null;
  subModelAr: string | null;
  redemptionFactor: number;
  storeId: string | null;
  transactionCount: number;
  store: any | null; // Schema not provided in JSON, presumed object or null
  offerTags: ProductTag[];
}

export interface UpdateProductBody {
  data: PickMulti<
    Product,
    ["offerNumber", "sortingNumber", "provider", "isFrontend"]
  > & {
    offerTags: {
      tagId: number;
      tagNameEn: string;
      tagNameAr: string;
    }[];
  };
}
